module.exports = __webpack_public_path__ + "static/img/3.0afbcc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/3.png
// module id = kLTv
// module chunks = 0